export const BankListData = [
  {
    id: '014',
    bankNo: '104001',
    bankName: 'Bank Central Asia',
    bankShortName: 'BCA'
  },
  {
    id: '009',
    bankNo: '104002',
    bankName: 'Bank Negara Indonesia',
    bankShortName: 'BNI'
  },
  {
    id: '002',
    bankNo: '104003',
    bankName: 'Bank Rakyat Indonesia',
    bankShortName: 'BRI'
  },
  {
    id: '022',
    bankNo: '104004',
    bankName: 'Bank CIMB Niaga',
    bankShortName: 'CIMB Niaga'
  },
  {
    id: '008',
    bankNo: '104005',
    bankName: 'Bank Mandiri',
    bankShortName: 'Mandiri'
  }
]
